<ion-item (click)="mainClick($event)" button="true">
  <ion-icon slot="start" size="large" [icon]="iconName"></ion-icon>
  <ion-label>
    <strong>{{ unit.Name }}</strong>
  </ion-label>
  <ion-chip *ngIf="crew" color="primary" slot="end">
    <ion-icon name="person"></ion-icon>
    <ion-label>{{ crew }}</ion-label>
  </ion-chip>
  <ion-chip *ngIf="vehicles" color="primary" slot="end">
    <ion-icon name="car"></ion-icon>
    <ion-label>{{ vehicles }}</ion-label>
  </ion-chip>
  <ion-icon name="location" size="large" slot="end" (click)="localize($event)" [appLocalizeUnit]="unit.ObjGuid"></ion-icon>
</ion-item>

<ion-card [class.ion-hide]="!opened">
  <ion-card-content>
    <app-unit-resources *ngIf="resources" [unit]="unit" [resources]="resources"></app-unit-resources>
    <ng-container *ngIf="!resources">
      <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 56%"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 68%"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
    </ng-container>
  </ion-card-content>
</ion-card>
